/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import store from './state/store';
Vue.use(Router);

const logExceptNavigationDuplicated = function (err) {
    //console.log("err ", err.name);
    typeof err === 'undefined' || err.name !== 'NavigationDuplicated' && console.error(err)
}

const notAuthenticated = (to, from, next) => {
    var isAuthenticated = store.getters['auth/loggedIn'];

    if (!isAuthenticated) {
        next();
        return;
    }
    next('/my-account');
};
const isAuthenticatedAndAdmin = (to, from, next) => {
    var isAuthenticated = store.getters['auth/adminLoggedIn'];
    if (isAuthenticated) {
        next();
        return;
    }
    router.push({
        path: '/login',
        query: {
            returnUrl: from.path
        }
    }).catch(logExceptNavigationDuplicated);
};
const isAuthenticated = (to, from, next) => {

    var isAuthenticated = store.getters['auth/loggedIn'];
    if (isAuthenticated) {
        next();
        return;
    }
    router.push({
        path: '/login',
        query: {
            returnUrl: from.path
        }
    }).catch(logExceptNavigationDuplicated);

};

const routes = [{
        path: "/",
        name: "home",
        component: Home,
        beforeEnter: isAuthenticated
    },
    { path: "*", name: "welcome-page", meta: { title: 'welcome' }, component: () => import("./views/Welcome.vue") },
    {
        path: "/about",
        name: "about",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import( /* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
        path: "/contact-us",
        name: "contact-us",
        component: () => import("./views/ContactUs.vue")
    },
    {
        path: "/admin",
        name: "admin",
        component: () => import("./views/admin/AdminHome.vue"),
        beforeEnter: isAuthenticatedAndAdmin
    },
    {
        path: "/my-account",
        name: "my-account",
        component: () => import("./views/user/MyAccount.vue"),
        beforeEnter: isAuthenticated
    },
    {
        path: "/register",
        name: "register",
        component: () => import("./views/user/Register.vue"),
        beforeEnter: notAuthenticated
    },
    {
        path: "/login/:returnUrl?",
        name: "login",
        component: () => import("./views/user/Login.vue"),
        beforeEnter: notAuthenticated
    },
    {
        path: "/logout",
        name: "logout",
        component: () => import("./views/user/Logout.vue"),
        beforeEnter: isAuthenticated
    },

    {
        path: "/view-seats/:id",
        name: "view-seats",
        component: () => import("./views/ViewSeats.vue"),
        beforeEnter: isAuthenticated
    },

    {
        path: "/user/twofactor-authentication",
        name: "user-twofactor-authentication",
        component: () => import("./views/user/Verify2Fa.vue"),
        beforeEnter: notAuthenticated
    },
    {
        path: "/user/confirm-email/:id/:code",
        name: "user-confirm-email",
        component: () => import("./views/user/ConfirmEmail.vue"),
        beforeEnter: notAuthenticated
    },
    {
        path: "/user/change-password",
        name: "user-change-password",
        component: () => import("./views/user/ChangePassword.vue"),
        beforeEnter: isAuthenticated
    },
    {
        path: "/user/forgotten-password",
        name: "user-forgotten-password",
        component: () => import("./views/user/ForgottenPassword.vue"),
        beforeEnter: notAuthenticated
    },
    {
        path: "/user/reset-password/:id/:code",
        name: "user-reset-password",
        component: () => import("./views/user/ResetPassword.vue"),
        beforeEnter: notAuthenticated
    },
    {
        path: "/user/bookings",
        name: "my-bookings",
        component: () => import("./views/user/Bookings.vue"),
        beforeEnter: isAuthenticated
    },
    /*-------------- events ------------------ */
    { path: "/admin/events", name: "events", component: () => import("./views/admin/events/List.vue"), beforeEnter: isAuthenticatedAndAdmin },
    { path: "/admin/events/edit/:id", name: "event-edit", component: () => import("./views/admin/events/Edit.vue"), beforeEnter: isAuthenticatedAndAdmin },
    { path: "/admin/events/add", name: "add-event", component: () => import("./views/admin/events/Add.vue"), beforeEnter: isAuthenticatedAndAdmin },
  
    /*-------------- /events ------------------ */    
    /*-------------- bookings ------------------ */
    { path: "/admin/bookings/:id", name: "bookings", component: () => import("./views/admin/bookings/List.vue"), beforeEnter: isAuthenticatedAndAdmin },
    //{ path: "/admin/bookings/edit/:id", name: "booking-edit", component: () => import("./views/admin/bookings/Edit.vue"), beforeEnter: isAuthenticatedAndAdmin },
    //{ path: "/admin/bookings/add", name: "add-booking", component: () => import("./views/admin/events/Add.vue"), beforeEnter: isAuthenticatedAndAdmin },

    /*-------------- /bookings ------------------ */ 
    
    /*-------------- users-admin ------------------ */ 
    { path: "/admin/users", name: "admin-users", component: () => import("./views/admin/users/List.vue"), beforeEnter: isAuthenticatedAndAdmin },
    { path: "/admin/user/:id", name: "admin-user-edit", component: () => import("./views/admin/users/Edit.vue"), beforeEnter: isAuthenticatedAndAdmin },

    { path: "/admin/roles", name: "roles", component: () => import("./views/admin/roles/List.vue"), beforeEnter: isAuthenticatedAndAdmin },
    { path: "/admin/role/:id", name: "role-edit", component: () => import("./views/admin/roles/Edit.vue"), beforeEnter: isAuthenticatedAndAdmin },

    /*-------------- /users-admin ------------------ */     
    
    
    
];

const router = new Router({
    routes
});

export default router;